import checkmarkIcon from 'assets/icons/checkmark.svg'
import { necessaryRolesColumns, teamCards, teamFootnote } from 'constants/ProjectSetUpConstants'

export const EstablishTeamPanel = () => {
  return (
    <div className="setup-panel-surface setup-panel-surface--team flex flex-col gap-4 items-start w-full">
      <p className="body-l w-full">
        The BVA work is carried out by a mix of different stakeholders with various levels and types of involvement, all
        lead by the Brand Lead.
      </p>

      <div className="flex flex-col gap-3 items-start w-full">
        {teamCards.map(card => (
          <div key={card.title} className="role-card w-full">
            <p className="subtitle-s mb-2">{card.title}</p>

            {card.intro && <p className="body-xs mb-2 w-full">{card.intro}</p>}

            {card.paragraphs?.map(paragraph => (
              <p key={paragraph} className="body-xs mb-2 w-full">
                {paragraph}
              </p>
            ))}

            {card.roles && (
              <div className="flex flex-col gap-4 w-full">
                {card.roles.map(role => (
                  <div key={role.name}>
                    <p className="subtitle-xxs">{role.name}</p>
                    <p className="body-xs">{role.description}</p>
                    {role.bullets && (
                      <ul className="role-card-bullets">
                        {role.bullets.map(bullet => (
                          <li key={bullet}>{bullet}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            )}

            {card.number && <span className="role-card-number">{card.number}</span>}
          </div>
        ))}

        <div className="necessary-roles-card w-full">
          <p className="subtitle-s mb-4">Necessary roles</p>
          <div className="necessary-roles-grid">
            {necessaryRolesColumns.map((column, index) => (
              <div key={index} className="necessary-roles-column">
                {column.map(role => (
                  <div key={role} className="necessary-roles-item">
                    <img src={checkmarkIcon} alt="" className="necessary-roles-check" />
                    <p className="body-xs">{role}</p>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>

      <p className="body-xs color-neutral-80">{teamFootnote}</p>
    </div>
  )
}
